import * as React from 'react';
import Svg, {SvgProps, Path} from 'react-native-svg';
const Policy = (props: SvgProps) => (
  <Svg width={128} height={128} viewBox="0 0 96 96" {...props}>
    <Path d="M16 48v40h39.7l-1.8-5.3c-1-2.8-1.8-6.4-1.9-8V72H32v-8h20v-8H32v-8.1l17.8.2c16.4.1 18.2 0 22-2 2.3-1.1 5-2.1 6.2-2.1 1.8 0 2-.6 2-6.2v-6.3L68.3 19.8 56.5 8H16v40zm47.5-23 11 11H52V25c0-6.1.1-11 .3-11 .1 0 5.2 4.9 11.2 11z" />
    <Path d="m69 55.9-8.5 3.8v10c0 9.3.2 10.3 3 14.9C66.6 89.6 74.7 96 78 96c3.3 0 11.4-6.4 14.5-11.4 2.8-4.6 3-5.6 3-14.9v-10L87 55.9c-4.7-2.1-8.7-3.8-9-3.8-.3 0-4.3 1.7-9 3.8z" />
  </Svg>
);
export default Policy;
